export default __webpack_public_path__ + "static/media/sql.01ca7246.png";